<app-header></app-header>
<div class="form-wrapper">
    <div class="container">
        <div class="logo-container pb-16">
            <div class="logo-wrapper">
				<img alt="tenderpilot-logo" src="../../../assets/logo/tp-logo-voll-quer.svg" width="390">
            </div>
        </div>
        <div *ngIf="isExist === 'true'" class="form">
            <div>
                <div class="title">
                    <span>{{'global.common.you_are_invited' | translate}} {{organizationName}}</span>
                </div>
                <form [formGroup]="invitation" nz-form class="forgot-password-form">

                    <app-input-field [size]="'large'" [form]="invitation" [placeholder]="'global.placeholder.password' | translate"
                        [formName]="'password'" class="password" [inputType]="passwordVisible ? 'text' : 'password'"
                        [nzSuffix]="suffixPasswordTemplate"
                        [label]="'global.placeholder.password' | translate"
						 [nzPrefix]="prefixIconPassword">
                    </app-input-field>


                    <ng-template #suffixPasswordTemplate>
                        <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible = !passwordVisible"></i>
                    </ng-template>

                    <ng-template #prefixIconPassword>
                        <i nz-icon nzTheme="outline" nzType="lock"></i>
                    </ng-template>

                    <app-input-field [size]="'large'" [form]="invitation" [placeholder]="'global.placeholder.confirm_password' | translate"
                        [formName]="'confirmPassword'" class="password"
                        [inputType]="confirmPasswordVisible ? 'text' : 'password'"
                        [nzSuffix]="suffixConfirmPasswordTemplate"
                        [label]="'global.placeholder.confirm_password' | translate" [nzPrefix]="prefixIconPassword">
                    </app-input-field>

                    <ng-template #suffixConfirmPasswordTemplate>
                        <i nz-icon [nzType]="confirmPasswordVisible ? 'eye-invisible' : 'eye'"
                            (click)="confirmPasswordVisible = !confirmPasswordVisible"></i>
                    </ng-template>
                    <div nz-row class="terms-conditions">
                        <div> {{ "global.sign_up.label.by_clicking_register" | translate }}
                            <a [href]="termsAndConditionsUrl">{{ "global.sign_up.label.terms_and_conditions" | translate
                                }}</a>
                            {{ "global.sign_up.label.and" | translate }}
                            <a [href]="privacyPolicyUrl">{{ "global.sign_up.label.privacy_policy" | translate }}</a>
                        </div>
                    </div>
                    <button *ngIf="userType === 'buyer'" class="user-form" nz-button class="login-form-button login-form-margin btn-color-default"
                        [nzType]="'primary'" (click)="acceptInvitationForExistingUser()" nzBlock>
                        {{ "global.common.accept" | translate }} </button>
                    <button *ngIf="userType === 'supplier'" class="user-form" nz-button class="login-form-button login-form-margin btn-color-default"
                        [nzType]="'primary'" (click)="acceptInvitationForExistingSupplierUser()" nzBlock>
                        {{ "global.common.accept" | translate }} </button>
                </form>
            </div>
        </div>
        <div *ngIf="isExist === 'false'" class="form">
            <div>
                <div class="title">
                    <span>{{'global.common.you_are_invited' | translate}} {{organizationName}}</span>
                </div>
                <form [formGroup]="invitationForNewUser" nz-form class="new-user">
                    <div class="user-form">
                        <app-input-field [size]="'large'"
                        [form]="invitationForNewUser"
                        [placeholder]="'global.placeholder.first_name' | translate"
                        [label]="'global.placeholder.first_name' | translate"
                        [formName]="'firstName'">
                        </app-input-field>
                    </div>
                    <div class="user-form">
                        <app-input-field [size]="'large'"
                        nzAutocomplete="off"
                        [form]="invitationForNewUser"
                        [placeholder]="'global.placeholder.last_name' | translate"
                        [formName]="'lastName'"
                        [label]="'global.placeholder.last_name' | translate">
                        </app-input-field>
                    </div>
                    <div class="user-form">
                        <div class="mb-3px color-text-default">{{ 'global.login.label.email' | translate }} :</div>
                        <input nz-input [placeholder]="email" nzSize="large" [disabled]="true"
                        />
                    </div>

                    <app-input-field [size]="'large'" [form]="invitationForNewUser"
                        [placeholder]="'global.login.placeholder.register_password' | translate" [formName]="'password'"
                        class="password" [inputType]="passwordVisible ? 'text' : 'password'"
                        [nzSuffix]="suffixPasswordTemplate"
                        [label]="'global.login.placeholder.register_password' | translate">
                    </app-input-field>

                    <ng-template #suffixPasswordTemplate>
                        <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible = !passwordVisible"></i>
                    </ng-template>

                    <app-input-field [size]="'large'" [form]="invitationForNewUser"
                        [placeholder]="'global.login.placeholder.confirm_password' | translate"
                        [formName]="'confirmPassword'" class="password"
                        [inputType]="confirmPasswordVisible ? 'text' : 'password'"
                        [nzSuffix]="suffixConfirmPasswordTemplate"
                        [label]="'global.login.placeholder.confirm_password' | translate">
                    </app-input-field>

                    <ng-template #suffixConfirmPasswordTemplate>
                        <i nz-icon [nzType]="confirmPasswordVisible ? 'eye-invisible' : 'eye'"
                            (click)="confirmPasswordVisible = !confirmPasswordVisible"></i>
                    </ng-template>


                    <div nz-row class="terms-conditions">
                        <div> {{ "global.sign_up.label.by_clicking_register" | translate }}
                            <a [href]="termsAndConditionsUrl">{{ "global.sign_up.label.terms_and_conditions" | translate
                                }}</a>
                            {{ "global.sign_up.label.and" | translate }}
                            <a [href]="privacyPolicyUrl">{{ "global.sign_up.label.privacy_policy" | translate }}</a>
                        </div>
                    </div>
                    <button *ngIf="userType === 'buyer'" class="user-form" nz-button class="login-form-button login-form-margin btn-color-default"
                        [nzType]="'primary'" (click)="acceptInvitationForNewUser()" nzBlock>
                        {{ "global.common.accept" | translate }} </button>
                        <button *ngIf="userType === 'supplier'" class="user-form" nz-button class="login-form-button login-form-margin btn-color-default"
                        [nzType]="'primary'" (click)="acceptInvitationForNewSupplierUser()" nzBlock>
                        {{ "global.common.accept" | translate }} </button>
                </form>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
